import { ReactNode } from 'react';

import { locator } from '../../testing/e2e-locator/locator';
import { Icon } from './Icon';
import { IconProps } from './types/IconProps';

export const InfoRoundedIcon = (props: IconProps): ReactNode => (
  <Icon {...props} testId={locator.components.icon.infoRounded}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1m1-8h-2V7h2z" />
  </Icon>
);
